import { Box, Button, TextField, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CustomTable from '../../components/table/Table'
import DownloadIcon from "@mui/icons-material/Download"
import { useDispatch, useSelector } from 'react-redux'
import { fetchLeads } from '../../redux/Slice/LeadSlice'
import { useNavigate } from 'react-router-dom'
import dayjs from 'dayjs';
import { setLoading } from '../../redux/Slice/loaderSlice'
import { clearMessage } from '../../redux/Slice/message'
import { toast } from 'sonner'

const columns = [
    { id: 'leadNo', label: 'Lead No', minWidth: 50, align:'start' },
    { id: 'company_name', label: 'Company Name', minWidth: 150, align:'start' },
    { id: 'contact_info', label: 'Contact Info', minWidth: 150, align:'start' },
    { id: 'last_follow_up', label: 'Last Follow-Up', minWidth: 150, align:'start' },
    { id: 'next_follow_up', label: 'Next Follow-Up', minWidth: 150, align:'start' },
    { id: 'followup_notes', label: 'Follow-Up Notes', minWidth: 150, align:'start' },
    { id: 'action', label: 'Action', minWidth: 100, align:'center', actionType: [{edit: true, view: true}] },
  ];

const LeadFollowUps = () => {
    const { leads, totalPages } = useSelector((state) => state.leads);
    const message = useSelector((state) => state.message);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    const [searchTerm, setSearchTerm] = useState("");
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [filteredLeadsCount, setFilteredLeadsCount] = useState(0);

    const transformLeads = (leads) =>
        leads
            .filter(lead => lead.followUps && lead.followUps.length > 0)
            .map((lead) => ({
                _id: lead._id,
                leadNo: lead.lead_id,
                company_name: lead?.companyName || "N/A",
                contact_info: lead.contactPerson[0]?.email + " / " + lead.contactPerson[0]?.phoneNumber || "N/A", 
                assigned_employee: lead.current_assignment_employee_id?.name || "N/A",
                last_follow_up: lead.followUps?.[0]?.last_followUp_date ? 
                    dayjs(new Date(lead.followUps[0].last_followUp_date)).format('DD MMM ddd YYYY\n hh.mm A') : "N/A", 
                next_follow_up: lead.followUps?.[0]?.next_followUp_date ? 
                    dayjs(new Date(lead.followUps[0].next_followUp_date)).format('DD MMM ddd YYYY\n hh.mm A') : "N/A", 
                followup_notes: lead.followUps?.[0]?.follow_up_notes || "N/A",
                action: "", 
            }));

    const modifiedRows = leads ? transformLeads(leads) : [];

    useEffect(() => {
        if (leads) {
            const filteredLeads = leads.filter(lead => lead.followUps && lead.followUps.length > 0);
            setFilteredLeadsCount(filteredLeads.length);
        }
    }, [leads]);

    useEffect(() => {
        // dispatch(setLoading(true));
        dispatch(fetchLeads({ page: page, limit: rowsPerPage, searchTerm })) 
            // .then(() => {
            //     dispatch(setLoading(false));
            // })
            // .catch(() => {
            //     dispatch(setLoading(false));
            // });
    }, [dispatch, page, rowsPerPage, searchTerm]);

    useEffect(() => {
        if (message?.message) {
            toast(message.message)
            dispatch(clearMessage())
        }
    }, [message, dispatch])

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
        setPage(1); 
    };
    
    const handleExport = () => {
        console.log("Exporting data...");
    };
    
    const handleEdit = () => {
        console.log("Yasar");
    };

    const handleView = (row) => {
        if (row._id) {
            navigate(`/lead/${row._id}`);
        } else {
            console.log("No lead ID found for this row", row);
        }
    };

    return (
        <Box className="content">
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <Typography variant="h5" sx={{ mb: 3, mt: 3 }}>
                    Lead Followups <Typography component="span">({filteredLeadsCount})</Typography>
                </Typography>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <TextField 
                        size="small" 
                        placeholder="Search by Leads Followups" 
                        value={searchTerm} 
                        onChange={handleSearch} 
                        fullWidth 
                    />
                    <Button 
                        variant="contained" 
                        startIcon={<DownloadIcon />} 
                        onClick={handleExport} 
                        sx={{ ml: 2, px: 3 }}
                    >
                        Export
                    </Button>
                </Box>
            </Box>

            <CustomTable
                columns={columns}
                rows={modifiedRows}
                page={page}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                totalCount={filteredLeadsCount}
                handleEdit={handleEdit}
                handleView={handleView}
            />
        </Box>
    );
}

export default LeadFollowUps;